// assets/custom-language-cart-reapply.js
(() => {
  'use strict';

  const DEFAULT_FROM = 'it';

  // SOLO cross-sell
  const ALLOWED_SOURCES = new Set(['cart-drawer-cross-sell']);

  const DEBOUNCE = 160;
  const MIN_INTERVAL = 1200;

  let t = null;
  let last = 0;

  function getCurrentLang() {
    return (window.__clswitch_currentLang || DEFAULT_FROM).toLowerCase();
  }

  function canTranslateNow() {
    return typeof window.doGTranslate === 'function';
  }

  function reapply() {
    const lang = getCurrentLang();
    if (!lang || lang === DEFAULT_FROM) return;
    if (!canTranslateNow()) return;

    const now = Date.now();
    if (now - last < MIN_INTERVAL) return;
    last = now;

    // una passata: non cambia lingua, forza traduzione dei nuovi nodi
    window.doGTranslate(`${DEFAULT_FROM}|${lang}`);
  }

  document.addEventListener('cart:update', (ev) => {
    const sourceId = ev?.detail?.sourceId || ev?.detail?.data?.source || '';
    if (!ALLOWED_SOURCES.has(sourceId)) return;

    clearTimeout(t);
    t = setTimeout(reapply, DEBOUNCE);
  });
})();